import { render, staticRenderFns } from "./Editar-Post.vue?vue&type=template&id=a0bb131e&scoped=true&"
import script from "./Editar-Post.vue?vue&type=script&lang=js&"
export * from "./Editar-Post.vue?vue&type=script&lang=js&"
import style0 from "./Editar-Post.vue?vue&type=style&index=0&id=a0bb131e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bb131e",
  null
  
)

component.options.__file = "Editar-Post.vue"
export default component.exports